import axios, { AxiosInstance } from 'axios';
import { getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { clearSessionOnUnauthorized } from '@/lib/clearSessionOnUnauthorized';

class Client {
  private _client: AxiosInstance;

  get client() {
    return this._client;
  }

  constructor() {
    const baseURL = process.env.NEXT_PUBLIC_BASE_API_URL;

    if (!baseURL) {
      throw Error('Environment keys for API client are not defined');
    }

    this._client = axios.create({
      baseURL,
      responseType: 'json',
      timeout: 10000,
    });
    this._client.interceptors.request.use(async (config) => {
      // Insert authorization bearer token into every request if it exists
      // Only try to get Firebase token if Firebase is initialized
      try {
        const apps = getApps();
        if (apps.length > 0) {
          const auth = getAuth();
          const token = await auth?.currentUser?.getIdToken();
          if (token && token !== localStorage.getItem('authToken')) {
            localStorage.setItem('authToken', token); 
          }
        }
      } catch (error) {
        // Firebase not initialized, skip token retrieval
        // This is expected for external pages that don't use Firebase auth
      }

      const authToken = localStorage.getItem('authToken');
      if (authToken) {
        return {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${authToken}`,
          },
        };
      }

      return config;
    });
    this._client.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error?.response?.status === 401) {
          clearSessionOnUnauthorized();
          console.error('User logged out: 401 Unauthorized');
        }
        return Promise.reject(error);
      }
    );
  }
}

export const API = new Client().client;
